import { SidenavController } from "./sidenav.controller";
import "./link.component";

angular
    .module("thor.shared.sidenav.component", [
        "thor.shared.sidenav.link.component"
    ])
    .component("thorSidenav", {
        controller: SidenavController,
        controllerAs: "sidenavCtrl",
        template: require("../../shared/sidenav/sidenav.html")
    });
